import { getSysUserDetails } from '../api/api';

export const AUTH_ROUTER_STORAGE_KEY = 'recording_authRouter';

function normalizeRoutePath(path) {
  if (!path) {
    return '';
  }

  const cleanPath = path
    .split('?')[0]
    .split('#')
    .filter(Boolean)
    .join('#')
    .replace(/^#/, '')
    .replace(/^\/?Home\//, '')
    .replace(/^\//, '')
    .replace(/\/$/, '');

  return cleanPath;
}

function getRouteTarget(item) {
  if (!item) {
    return '';
  }

  if (item.authUrl) {
    return item.authUrl;
  }

  if (item.authRemark) {
    const authRemark = item.authRemark.replace(/^#/, '');
    return authRemark.startsWith('/') ? authRemark : `/${authRemark}`;
  }

  return '';
}

export function getStoredAuthRouter() {
  const authRouter = localStorage.getItem(AUTH_ROUTER_STORAGE_KEY);

  if (!authRouter) {
    return [];
  }

  try {
    return JSON.parse(authRouter);
  } catch (error) {
    console.error('parse auth router failed:', error);
    localStorage.removeItem(AUTH_ROUTER_STORAGE_KEY);
    return [];
  }
}

export async function fetchAndStoreAuthRouter() {
  const res = await getSysUserDetails();

  if (!res || res.status !== 200) {
    throw new Error(res?.msg || '获取权限失败');
  }

  const authList = res.data?.ayRoleAuthList || [];
  localStorage.setItem(AUTH_ROUTER_STORAGE_KEY, JSON.stringify(authList));

  return authList;
}

export function checkPathInAuth(path, authList = []) {
  const currentPath = normalizeRoutePath(path);

  if (!currentPath) {
    return false;
  }

  return authList.some((item) => {
    if (normalizeRoutePath(item.authRemark) === currentPath || normalizeRoutePath(item.authUrl) === currentPath) {
      return true;
    }

    if (!item.children || item.children.length === 0) {
      return false;
    }

    return item.children.some((child) => {
      return normalizeRoutePath(child.authRemark) === currentPath || normalizeRoutePath(child.authUrl) === currentPath;
    });
  });
}

export function getFirstAccessibleRoute(authList = []) {
  for (const item of authList) {
    if (item.children && item.children.length > 0) {
      const firstChildRoute = getRouteTarget(item.children[0]);

      if (firstChildRoute) {
        return firstChildRoute;
      }
    }

    const currentRoute = getRouteTarget(item);

    if (currentRoute) {
      return currentRoute;
    }
  }

  return '';
}
